import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.quotes.data.FranchiseeQuoteAddressManager.';
  public static readonly project = `${Id.prefix}project`;
  public static readonly client = `${Id.prefix}client`;
  public static readonly franchisee = `${Id.prefix}franchisee`;
  public static readonly other = `${Id.prefix}other`;
  public static readonly willCall = `${Id.prefix}willCall`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangFranchiseeQuoteAddressManager {
  private constructor() {}
  public static project(): string {
    return interpolate(Id.project);
  }
  public static client(): string {
    return interpolate(Id.client);
  }
  public static franchisee(): string {
    return interpolate(Id.franchisee);
  }
  public static other(): string {
    return interpolate(Id.other);
  }
  public static willCall(): string {
    return interpolate(Id.willCall);
  }
}

export class FranchiseeQuoteAddressManagerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.project, "{{glossary 'project'}}", 'Label for project address');
    register.add(Id.client, "{{glossary 'client'}}", 'Label for client address');
    register.add(Id.franchisee, "{{glossary 'franchisee'}}", 'Label for franchisee/branch address');
    register.add(Id.other, 'Other', 'Label for other address');
    register.add(Id.willCall, 'Will Call', 'Label for will call address');
  }
}
